import styled from 'styled-components'

export const MonthTitle = styled.h3`
  font-size: 1.25rem;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  display: flex;
  gap: 10px;
`
